module.exports = __webpack_public_path__ + "static/media/31.10.adfe20d6.jpg";